module.exports = __webpack_public_path__ + "static/ellen-armstrong-pic-5-90ab41f7f90c3d0c16137d947ca7c7aa.jpg";